import React from 'react';
import { inr } from './ProfitWaterfall';

const COLS = {
  salesperson: [['name', 'Salesperson'], ['region', 'Region']],
  region: [['region', 'Region']],
  month: [['month', 'Month']],
};

// One table for salesperson / region / month breakdowns.
export default function ProfitTable({ rows, by }) {
  if (!rows.length) return <p className="text-sm text-[#6D8E87] p-6" data-testid={`profit-table-${by}-empty`}>No won orders in this period.</p>;
  return (
    <div className="overflow-x-auto" data-testid={`profit-table-${by}`}>
      <table className="w-full text-sm">
        <thead className="text-xs text-[#6D8E87] uppercase tracking-wide">
          <tr className="border-b border-[#D5E8E4]">
            {COLS[by].map(([, l]) => <th key={l} className="text-left py-2 px-3">{l}</th>)}
            {['Orders', 'Revenue', 'GM %', 'Contribution', 'Own salary', 'Shared costs', 'Net profit', 'Net %'].map((h) => <th key={h} className="text-right py-2 px-3">{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} className={`border-b border-[#EEF5F3] hover:bg-[#F4F9F7] transition-colors ${r.net_profit < 0 ? 'bg-rose-50/50' : ''}`} data-testid={`profit-row-${by}-${i}`}>
              {COLS[by].map(([k]) => <td key={k} className="py-2 px-3 text-[#052A23]">{r[k]}{k === 'name' && r.role ? <span className="block text-[11px] text-[#6D8E87]">{r.role}</span> : null}</td>)}
              <td className="py-2 px-3 text-right tabular-nums">{r.orders}</td>
              <td className="py-2 px-3 text-right tabular-nums">{inr(r.revenue + r.transport)}</td>
              <td className="py-2 px-3 text-right tabular-nums">{r.gm_pct == null ? '—' : `${r.gm_pct}%`}</td>
              <td className="py-2 px-3 text-right tabular-nums">{inr(r.contribution)}</td>
              <td className="py-2 px-3 text-right tabular-nums">{inr(-r.own_salary)}</td>
              <td className="py-2 px-3 text-right tabular-nums">{inr(-r.shared_costs)}</td>
              <td className={`py-2 px-3 text-right tabular-nums font-semibold ${r.net_profit < 0 ? 'text-rose-700' : 'text-[#00857e]'}`}>{inr(r.net_profit)}</td>
              <td className="py-2 px-3 text-right tabular-nums">{r.net_margin_pct == null ? '—' : `${r.net_margin_pct}%`}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
